/* eslint-disable  */
//@ts-nocheck
'use strict';

import React from 'react';
import ajax from '../../../../components/ajax';
import _ from 'lodash';
import { ProgramMenu } from './ProgramMenu';
import { ProgramSection } from './ProgramSection';
import produce from 'immer';

type ProgramPageProps = {
  refreshWorkouts: Function;
  params: {
    programId?: string;
  };
  influencer: {
    customizations: {
      hideLibrary: boolean;
    };
  };
  influencerId: number;
  programs: any[];
  workoutsLoading?: boolean;
  updateQuery: any;
};
export class ProgramPage extends React.Component<ProgramPageProps> {
  constructor(props) {
    super(props);
    this.state = {
      programId: this.selectedProgramId() || 0,
    };
  }

  shouldShowLibrary() {
    return this.props.influencer?.customizations?.hideLibrary === false;
  }

  selectedProgramId = () => {
    // Library has ID = 0, and one needs !hideLibrary
    const LIBRARY_ID = 0;
    const showLibrary = this.shouldShowLibrary();

    const paramDefinedInURL = this.props.params.programId !== undefined;
    const paramsProgramId = paramDefinedInURL
      ? parseInt(this.props.params.programId)
      : null;

    const requestedProgramId = paramDefinedInURL
      ? paramsProgramId
      : showLibrary
      ? LIBRARY_ID
      : null;

    return requestedProgramId != null
      ? requestedProgramId
      : this.props.programs?.length
      ? this.props.programs[0].id
      : null;
  };

  updateProgram(update) {
    this.props.updateQuery((data) => {
      return produce(data, ({ creator }) => {
        const selectedProgram = creator.programs.find((p) => p.id == update.id);
        Object.assign(selectedProgram, update);
      });
    });
  }

  onChange = () => {
    this.props.refreshWorkouts();
  };

  onReorder = (programId, workoutIds) => {
    ajax
      .reorderProgram(programId, workoutIds)
      .then(() => {
        this.props.refreshWorkouts();
      })
      .catch((e) => {
        console.error('[WorkoutList] Error performing Program reorder.', e);
      });
  };

  render() {
    const { influencer, programs } = this.props;
    const libraryId = 0;
    const selectedProgramId = this.selectedProgramId();
    const selectedProgram =
      selectedProgramId === libraryId
        ? {
            id: libraryId,
            name: 'Library',
            isVisible: true,
            workouts: programs
              .filter((p) => p.accessType !== 'exclusive')
              .flatMap((p) => p.workouts ?? [])
              .sort(descSortByDate('publishedAt')),
          }
        : programs.find((p) => p.id == selectedProgramId);
    return (
      <section className="channel">
        <ProgramMenu
          creatorId={this.props.influencerId}
          showLibrary={this.shouldShowLibrary()}
          programs={programs}
          selectedProgramId={selectedProgramId}
        />
        {this.props.workoutsLoading ? (
          <div className="newWorkoutList">Loading...</div>
        ) : (
          Boolean(selectedProgram) && (
            <ProgramSection
              influencerId={this.props.influencerId}
              influencer={influencer}
              key={selectedProgram?.id}
              program={selectedProgram}
              onReorder={this.onReorder}
              onChange={this.onChange}
            />
          )
        )}
      </section>
    );
  }
}

function descSortByDate(prop: string) {
  return (a, b) => new Date(b[prop]).getTime() - new Date(a[prop]).getTime();
}
